import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosProgress } from '../api';
import jwtDecode from 'jwt-decode';
import services from '../index';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

// GET: Para obter a imagem atual da tela de login (sem autenticação)
export const getLoginImage = async () => {
    try {
        const response = await _sendWithAxios(`${REACT_APP_URL_BASE_API}urllogin/imagem-ativa`, 'GET');
        
        // Se a resposta foi bem-sucedida e tem dados
        if (response && !response.fail && response.data && response.data.url) {
            return {
                data: {
                    id: response.data.id,
                    urlArquivo: response.data.url, // API retorna 'url', frontend espera 'urlArquivo'
                    dataAtualizacao: response.data.dataCriacao // API retorna 'dataCriacao', frontend espera 'dataAtualizacao'
                },
                fail: null
            };
        }
        
        // Se não houver imagem ativa, retorna null (sem fallback)
        return {
            data: null,
            fail: null
        };
    } catch (error) {
        // Se houver erro (404 ou outro), retorna null
        console.log('Nenhuma imagem ativa encontrada');
        return {
            data: null,
            fail: error
        };
    }
}

// POST: Para atualizar/trocar a imagem da tela de login
// IMPORTANTE: Esta função espera receber a URL da imagem já fazendo upload
// O fluxo correto é: 1) uploadLoginImage() para fazer upload e obter URL, 2) postLoginImage(url) para salvar no banco
export const postLoginImage = async (urlImagem) => {
    try {
        // Obtém o userId do token (precisa estar autenticado)
        const user = services.storage.getUser();
        if (!user || !user.IdUser) {
            throw new Error("Usuário não autenticado ou IdUser não encontrado no token");
        }

        const userId = user.IdUser;

        const data = {
            userId: userId,
            url: urlImagem,
            dataCriacao: new Date().toISOString(),
            status: true // Sempre ativa a nova imagem
        };

        const response = await _sendWithAxios(`${REACT_APP_URL_BASE_API}urllogin`, 'POST', data);
        
        // Ajusta o formato da resposta para compatibilidade com o frontend
        if (response && response.data) {
            return {
                data: {
                    id: response.data.id,
                    urlArquivo: response.data.url,
                    dataAtualizacao: response.data.dataCriacao
                },
                fail: null
            };
        }
        
        return {
            data: null,
            fail: "Resposta inválida da API"
        };
    } catch (error) {
        console.error('Erro ao salvar imagem de login:', error);
        return {
            data: null,
            fail: error
        };
    }
}

// Função para upload de arquivo para Azure Storage (similar ao uploadBanner)
export const uploadLoginImage = async (file, folder = 'login-image', options) => {
    try {
        const data = new FormData();
        data.append("file", file);
        const response = await _sendWithAxios(`${REACT_APP_URL_BASE_API}urllogin/upload-files/${folder}`, 'POST', data, options);
        
        // A resposta vem como string com URLs separadas por ';'
        // Para login image, geralmente é apenas uma URL
        if (response && response.data) {
            const url = typeof response.data === 'string' ? response.data.split(';')[0] : response.data;
            return {
                data: url,
                fail: null
            };
        }
        
        return {
            data: null,
            fail: "Resposta inválida da API"
        };
    } catch (error) {
        console.error('Erro ao fazer upload da imagem:', error);
        return {
            data: null,
            fail: error
        };
    }
}

